import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

export var HTTPError = /*#__PURE__*/function (_Error) {
  _inherits(HTTPError, _Error);

  var _super = _createSuper(HTTPError);

  function HTTPError(response, request, options) {
    var _this;

    _classCallCheck(this, HTTPError);

    var code = response.status || response.status === 0 ? response.status : '';
    var title = response.statusText || '';
    var status = "".concat(code, " ").concat(title).trim();
    var reason = status ? "status code ".concat(status) : 'an unknown error';
    _this = _super.call(this, "Request failed with ".concat(reason));
    _this.name = 'HTTPError';
    _this.response = response;
    _this.request = request;
    _this.options = options;
    return _this;
  }

  return HTTPError;
}( /*#__PURE__*/_wrapNativeSuper(Error));